import { render, staticRenderFns } from "./PoliciesCompany.vue?vue&type=template&id=968053bc&scoped=true&"
import script from "./PoliciesCompany.vue?vue&type=script&lang=ts&"
export * from "./PoliciesCompany.vue?vue&type=script&lang=ts&"
import style0 from "./PoliciesCompany.vue?vue&type=style&index=0&id=968053bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968053bc",
  null
  
)

export default component.exports